module.exports = __webpack_public_path__ + "media/images/person/review_james-90d0cc43b4eaf749a753e69da9b5a350.jpg";